import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ProductCatalogsRepository from '../../domains/informacionDevolucion/repositories/product-catalogs-repository';

const initialState = {
    bancos: [],
    tiposCuenta : [],
    activarOtros : false,
    status: "idle",
    error: "",
    getBank : null
};

export const getProductCatalog = createAsyncThunk("productCatalog/getProductCatalog", async () => {
    return await new ProductCatalogsRepository().getObtenerCatalogos().then((resp) => { return resp.data; });
})

export const productCatalogSlice = createSlice({
    name : "productCatalog",
    initialState,
    reducers : {
        getBank     : (state, action) => {
            state.getBank = state.bancos.find((bank) => bank.codigoBanco === action.payload);
        },
        onChangeActivarOtros  : (state, action) => {
            state.activarOtros = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase( getProductCatalog.pending, (state) => {
                state.status = "loading";
            })
            .addCase( getProductCatalog.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.bancos = action.payload.datos.bancos;
                state.tiposCuenta = action.payload.datos.tiposCuenta;
            })
            .addCase( getProductCatalog.rejected, (state, action) => {
                state.status = "failed";
                state.error = "Ocurrio un error al procesar su solicitud.";
            });
    }
});

export const { getBank, onChangeActivarOtros } = productCatalogSlice.actions;
export default productCatalogSlice.reducer;